const initializeYearInputs = () => {
    const yearMin = document.querySelector('input[name="year_founded_min"]');
    const yearMax = document.querySelector('input[name="year_founded_max"]');

    const validateYearRange = () => {
        const minYearValue = parseInt(yearMin?.value, 10);
        const maxYearValue = parseInt(yearMax?.value, 10);

        if (yearMin?.value && yearMax?.value && minYearValue > maxYearValue) {
            yearMin.setCustomValidity('Min year cannot be greater than max year');
            yearMax.setCustomValidity('Max year cannot be less than min year');
        } else {
            yearMin?.setCustomValidity('');
            yearMax?.setCustomValidity('');
        }
    };

    const validateYearInput = (input) => {
        const min = parseInt(input.getAttribute('min'), 10);
        const max = parseInt(input.getAttribute('max'), 10);
        const value = parseInt(input.value, 10);

        input.setCustomValidity(value < min || value > max ? `Year must be between ${min} and ${max}` : '');

        validateYearRange();
    };

    yearMin?.addEventListener('input', (e) => {
        const input = e.target;
        if (input.value.length > 4) {
            input.value = input.value.slice(0, 4);
        }
        validateYearInput(input);
    });

    yearMax?.addEventListener('input', (e) => {
        const input = e.target;
        if (input.value.length > 4) {
            input.value = input.value.slice(0, 4);
        }
        validateYearInput(input);
    });
};

const prettifyURL = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Remove empty parameters
    for (let [key, value] of params.entries()) {
        if (!value || value.trim() === '') {
            params.delete(key);
        }
    }

    // Decode common URL-encoded characters
    const decodeParam = (param) => {
        return (
            param
                .replace(/%5B/g, '[')
                .replace(/%5D/g, ']')
                .replace(/%20/g, '+')
                // .replace(/\+/g, ' ')
                .replace(/%3A/g, ':')
                .replace(/%2F/g, '/')
                .replace(/%3D/g, '=')
                .replace(/%26/g, '&')
                .replace(/%3F/g, '?')
                .replace(/%40/g, '@')
                .replace(/%2C/g, ',')
        );
    };

    // Convert URLSearchParams to a clean string with decoded characters
    let cleanParams = params.toString();
    cleanParams = decodeParam(cleanParams);

    // Update the browser's URL without reloading the page
    const niceUrl = `${url.origin}${url.pathname}${cleanParams ? '?' + cleanParams : ''}`;
    window.history.replaceState({}, '', niceUrl);
};

const inactiveSchools = () => {
    const inactiveBox = document.getElementById('hide_inactive_box');
    if (inactiveBox) {
        inactiveBox.addEventListener('change', (event) => {
            document.getElementById('hide_inactive').value = event.target.checked ? 1 : 0;
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initializeYearInputs();
    prettifyURL();
    inactiveSchools();
});
